/* Utilities */
import { delegateMSTEvent } from '~/src/utils/analytics';
import analyticsService from '~/src/services/analytics';

/* Events */
const actionEvents = {
  update: (actionArgs, rootStore) => {
    const userId = rootStore.user.profile?.id;

    analyticsService.track('Profile Updated', {
      user_id: userId,
    });
  },
  uploadPhoto: () => {
    analyticsService.track('Profile Avatar Uploaded');
  },
  removePhoto: () => {
    analyticsService.track('Profile Avatar Removed');
  },
  disableTwoFactorAuth: () => {
    analyticsService.track('Account 2FA Disabled');
  },
  enableTwoFactorAuth: (actionArgs) => {
    const [type] = actionArgs;
    analyticsService.track('Account 2FA Enabled', {
      type,
    });
  },
  changePassword: () => {
    analyticsService.track('Account Password Changed');
  },
  revokeMemberInvitation: (actionArgs) => {
    const [memberId] = actionArgs;

    analyticsService.track('Account Member Invitation Revoked', {
      memberId,
    });
  },
  resendMemberInvitation: (actionArgs) => {
    const [memberId] = actionArgs;

    analyticsService.track('Account Member Invitation Resent', {
      memberId,
    });
  },
  removeMember: (actionArgs) => {
    const [memberId] = actionArgs;
    analyticsService.track('Account Member Removed', {
      memberId,
    });
  },

  inviteUsers: (actionArgs) => {
    const [emails, isAdmin] = actionArgs;

    emails.split(',').forEach(() => {
      analyticsService.track('Account Member Invited', {
        isAdmin,
      });
    });
  },
};

const flowReturnEvents = {
  createSubscription: (actionArgs) => {
    const [subscription] = actionArgs;
    if (!subscription) {
      return;
    }

    let properties = {
      subscriptionCoupon: subscription.coupon,
      subscriptionNumberOfSeats: subscription.seats,
      subscriptionPlanName: subscription.name,
    };

    if (subscription && subscription.plan && subscription.plan.id) {
      properties = {
        planId: subscription.plan.id,
        subscriptionCoupon: subscription.coupon,
        subscriptionStatus: subscription.status,
        subscriptionRenewalDate: subscription.current_period_end,
        subscriptionCancelledData: subscription.canceledAt,
        subscriptionNumberOfSeats: subscription.quantity,
        subscriptionPlanName: subscription.plan.name,
        subscriptionPlanAmount: subscription.plan.amount,
        subscriptionPlanInterval: subscription.plan.interval,
      };
    }

    analyticsService.track('Pro Account Subscribed', properties);
  },

  createSubscription_V2: (actionArgs) => {
    const [subscription] = actionArgs;
    if (!subscription) {
      return;
    }

    let properties = {
      subscriptionCoupon: subscription.coupon,
      subscriptionNumberOfSeats: subscription.seats,
      subscriptionStatus: subscription.status,
      currentPeriodStart: subscription.current_period_start,
      currentPeriodEnd: subscription.current_period_end,
      subscriptionDuration: subscription.duration,
    };

    properties.plan = subscription.plan.map((p) => {
      return {
        planId: p.fields.plan_id,
        planName: p.fields.name,
        planCreated: p.fields.plan_created,
        planInterval: p.fields.interval,
        planAmount: p.fields.amount,
        planNumberOfSeats: p.fields.quantity,
        productCode: p.fields.product,
        planQuantity: p.fields.quantity,
        planSubscriptionId: p.fields.plan_subscription_id,
      };
    });
    analyticsService.track('UP Account Subscribed', properties);
  },

  updateSubscription: (actionArgs) => {
    const [{ nextSubscription, previousSubscription }] = actionArgs;

    if (previousSubscription && nextSubscription) {
      analyticsService.track('Account Subscription Updated', {
        previousPlanId: previousSubscription.plan.id,
        previousSubscriptionStatus: previousSubscription.status,
        previousSubscriptionRenewalDate:
          previousSubscription.current_period_end,
        previousSubscriptionCancelledData: previousSubscription.canceledAt,
        previousSubscriptionNumberOfSeats: previousSubscription.quantity,
        previousSubscriptionPlanName: previousSubscription.plan.name,
        previousSubscriptionPlanAmount: previousSubscription.plan.amount,
        previousSubscriptionPlanInterval: previousSubscription.plan.interval,
        nextPlanId: nextSubscription.plan.id,
        nextSubscriptionStatus: nextSubscription.status,
        nextSubscriptionRenewalDate: nextSubscription.current_period_end,
        nextSubscriptionCancelledData: nextSubscription.canceledAt,
        nextSubscriptionNumberOfSeats: nextSubscription.quantity,
        nextSubscriptionPlanName: nextSubscription.plan.name,
        nextSubscriptionPlanAmount: nextSubscription.plan.amount,
        nextSubscriptionPlanInterval: nextSubscription.plan.interval,
      });
    }
  },
};

export default (call, rootStore) => {
  return delegateMSTEvent(call, rootStore, {
    events: actionEvents,
    flowReturnEvents,
  });
};
